<template>
  <el-form class="reports-index">
    <div class="search-filter">
      <el-input placeholder="Поиск по номеру отчета" v-model="search" class="input-search">
        <el-button slot="append" icon="el-icon-search"></el-button>
      </el-input>
      <div style="display: flex; width: 100%; justify-content: space-between;" class="search-report-filter">
        <div class="filter-worker">
          <el-dialog
            append-to-body
            custom-class="search-report"
            title="Фильтры"
            :visible.sync="dialogVisible"
          >
            <div style="margin-top: -22px">
              <filter-select v-model="filter.executor" label="Исполнитель" :options="options.users"></filter-select>
              <filter-select v-model="filter.user" label="Создатель" :options="options.users"></filter-select>
            </div>
            <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">Ок</el-button>
          </span>
          </el-dialog>
          <div>
            <el-button style="width: 100%" @click="dialogVisible = true">Фильтры</el-button>
          </div>
        </div>
        <div class="filter">
          <date-picker
            :editable="false"
            v-if="render"
            ref="datePicker"
            placeholder="Фильтр по дате"
            v-model="datetimeRange"
            @change="changeDateTime"
            range
          ></date-picker>

        </div>
      </div>
    </div>
    <div class="reports-ul" style="min-height: 100px" v-loading="loading">
      <div :key="`${report.id}_${key}`"
           @click="select(report)"
           class="reports-li" v-for="(report, key) in filteredReports"
      >
        <div :class="['header-id']">
          <div style="display: flex; align-items: center">
            <span style="margin-left: 4px; margin-right: 4px; pointer-events: none">#{{ report.index }}</span>
            <i style="pointer-events: none" class="el-icon-success" v-if="report.approve"></i>
          </div>
          <span>{{ dayjs(report.datetime).format('DD/MM/YY') }}</span>
        </div>
        <span>Пользователь: <strong>{{ report.reporter ? report.reporter.name : '-'}}</strong></span>
        <span>Компания: <strong>{{  report.executor ? report.executor.label || report.executor.name :  (report.user ? report.user.company || report.user.name :  (report.reporter.company || '-'))}}</strong></span>
        <span>Объект: <strong>{{ report.object.name }}</strong></span>
      </div>
    </div>
  </el-form>
</template>

<script>
import firebase from 'firebase';
import dayjs from 'dayjs';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import {getPermissionByUser} from "../../../../firestore/permission";
import AddObject from "../../Documentation/components/AddObject";
import FilterSelect from "../../../../components/FilterSelect";
import {getUsersOptions} from "../../../../firestore/users";
import {getObjectOptions} from "../../../../firestore/objects";
import {getOptionsWorkorderCategories} from "../../../../firestore/workorder-categories";
import {formatEndDate, formatStartDate} from "../../../../utils/date";
import _ from "lodash";

export default {
  name: 'SearchReports',
  props: ['type', 'jobId', 'reports', 'mainForm', 'isEditable', 'user'],
  components: {FilterSelect, AddObject, DatePicker},
  data() {
    return {
      openDialog: false,
      search: '',
      role: 'admin',
      userSelect: null,
      dialogVisible: false,
      render: true,
      loading: true,
      options: {
        users: [],
        objects: [],
        categories: [],
      },
      filter: {
        object: '',
        executor: '',
        user: '',
        category: '',
        status: null
      },
      type_select: null,
      downloadForAll: false,
      downloadWithPrice: false,
      datetimeRange: [
        new Date(String(dayjs().utc().subtract(1, 'month').format('YYYY-MM-DD'))),
        new Date(String(dayjs().utc().format('YYYY-MM-DD'))),
      ],
    };
  },

  async mounted() {
    if (!this.$store.state.project.version) {
      this.permission = await getPermissionByUser(this.$store.state.project.id, authFirestore.currentUser.uid, this.$store.state.project.plan && this.$store.state.project.plan.id);
    }

    let query = {}

    if (this.$store.state.project.plan && this.$store.state.project.plan.id) {
      query.plan = this.$store.state.project.plan.id;
    }

    this.objects = await getObjectOptions(this.$store.state.project.id, this.permission, query);

    myFirestore
      .collection('projects')
      .doc(this.$store.state.project.id).get().then(async (sub) => {
      const data = sub.data();
      if (data) {
        const rules = data.rules;
        if (rules) {
          this.role = rules[authFirestore.currentUser.uid];
          if (data.isDemo) {
            this.role = 'admin';
          }
        }
      }
      setTimeout(async () => {
        // try {
        //   await this.fetchReports();
        // } catch (e) {}
        this.loading = false;
        this.fetchUsers();
        this.fetchCategories();
        this.fetchObjects();
      }, 200)
    });
  },

  methods: {
    select(report) {
      this.$emit('select', report)
    },
    dayjs,
    async fetchUsers() {
      this.loader = true;

      this.options.users = await getUsersOptions(this.$store.state.project.id);
      this.loading = false;
    },
    async fetchCategories() {
      this.loader = true;

      this.options.categories = await getOptionsWorkorderCategories(this.$store.state.project.id);

      this.loading = false;
    },
    async fetchObjects() {
      this.loader = true;

      this.options.objects = await getObjectOptions(this.$store.state.project.id);

      this.loading = false;
    },
    changeDateTime() {
      // if (this.datetimeRange[0] && this.datetimeRange[1]) {
      //   this.fetchReports();
      // }
    },
    navigate(report) {
    },
  },
  computed: {
    filteredReports() {

      const reports = _.orderBy(this.reports, 'index', ['desc']);

      const filterReports = _.orderBy(reports, 'deadline_dateunix', ['asc']);

      return [...(filterReports || [])].filter((report) => {
        if (this.filter.executor && this.filter.executor.value) {
          if ((report.executor && report.executor.uid) !== this.filter.executor.value) {
            return false;
          }
        }

        if (this.filter.user && this.filter.user && this.filter.user.value) {
          if ((report.reporter && report.reporter.name) !== this.filter.user.label) {
            return false;
          }
        }

        if(!dayjs(report.dateunix * 1000).isBetween(this.datetimeRange[0], this.datetimeRange[1], null, '[]')) {
          return  false
        }


        if(!this.isEditable) {
          if(this.user.role === 'worker') {
            if(report.reporter.uid !== authFirestore.currentUser.uid && report.userId !== authFirestore.currentUser.uid) {
              return false
            }
          }

          if(this.user.role === 'editor') {
            if((report.executor && report.executor.name === this.user.company)
              || (report.user && report.user.company === this.user.company)
              || (report.reporter && report.reporter.company === this.user.company)
            ) {
            } else {
              return false
            }
          }
        }

        if (this.search) {
          return report.index == this.search
        }


        return true

      });
    },
  },
};
</script>

<style scoped lang="scss">
.reports-index {
  max-width: 1024px;
  margin: -22px auto 0;
}

> > > .el-form-item {
  margin-bottom: 0;
}

.reports-ul {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
}

.reports-li {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-bottom: 1px solid rgba(0, 0, 0, 0.18);
  padding: 10px 14px;
  text-decoration: none;
  color: #000;

  span {
    text-align: left;
  }

  &--child {
    width: 100%;
    display: flex;
    text-decoration: none;
    cursor: pointer;
    flex: 1;
    flex-direction: column;
    align-items: flex-start;

  }

  .header-id {
    display: flex;
    justify-content: space-between;
    margin-bottom: 6px;
    width: 100%;
  }

  span {
    font-size: 14px;
    color: #2c3e50;
  }

  span:first-child {
    margin-right: 20px;
  }


  span {
    margin-right: 5px;
  }

  &:hover {
    background: #f5f5f5;
  }
}

> > > .el-date-editor--daterange.el-input__inner {
  width: 100%;
  margin-top: 10px;
}

.add-block {
  button {
    width: 100%;
    margin-top: 10px;
  }
}

.search-filter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 260px;
  flex-direction: column;

  .input-search {
    min-width: 260px;
  }

  .filter-btn {
    margin-top: 10px;
    margin-left: 10px;
  }
}

.create-new {
  display: flex;
  justify-content: flex-start;
}

.jobs-list {
  display: flex;
  flex-direction: column;
}

@media screen and (max-width: 764px) {
  .filter-dialog-button {
    width: 100% !important;
  }
  .search-filter {
    flex-direction: column;

    .filter {
      width: 100%;
    }
  }

  .filter-btn {
    width: 100%;
    margin-left: 0 !important;

    button {
      width: 100%;
    }
  }
  .reports-index {
    padding: 0 0 !important;
  }

  .search-filter .input-search {
    margin-right: 0;
  }

  .filter-worker {
    width: auto;

    .el-form-item {
      margin-bottom: 0;
    }

    .el-select {
      width: 100%;
    }
  }
}

.create-new {
  display: flex;
  justify-content: space-between;
}

.filter {
  min-width: 260px;
}

.filter-worker {
  margin-top: 10px;
  margin-right: 5px;
}

.mx-datepicker-range {
  width: 100%;
  margin-top: 10px;

  .mx-input {
    border: 1px solid #DCDFE6;
    height: 40px;
  }
}

.disabled {
  opacity: 0.7;
}

.mb-1 {
  margin-bottom: 10px;
}


.create-new {
  display: flex;
  align-items: center;

  .add-block button {
    margin-top: 0 !important;
  }
}

.type-create {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  i {
    margin-left: 16px;
    font-size: 28px;
    cursor: pointer;
  }
}

.el-icon-success {
  color: #2ecc71;
}
@media screen and (max-width: 700px) {

  .search-report-filter {
    flex-direction: column !important;
  }
}
</style>
<style lang="scss">
.search-filter {
  .filter-worker {
    width: 100%;

    .el-form-item {
      margin-bottom: 0 !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Workorder/components/SearchReports.vue